import type { TierStatusSummaryRowResponse } from "@/apiClient/models/TierStatusSummaryRowResponse";
import Badge from "@/components/storageOps/Badge";
import {
  ROW_STATUS_BADGE_CLASSES,
  formatAgeSince,
} from "@/components/storageOps/storageOps.utils";

function StatusSummaryPanel({
  rows,
  isLoading,
}: {
  rows: TierStatusSummaryRowResponse[];
  isLoading: boolean;
}) {
  return (
    <section className="rounded-lg border border-slate-200 bg-white">
      <div className="border-b border-slate-100 px-5 py-3">
        <h2 className="text-lg font-semibold text-blue-200">In-Flight Rows</h2>
        <p className="text-xs text-grey-200">
          Links currently moving through the tiering pipeline, including
          rehydrations.
        </p>
      </div>

      {isLoading ? (
        <p className="px-5 py-4 text-sm text-grey-200">Loading...</p>
      ) : rows.length === 0 ? (
        <p className="px-5 py-4 text-sm text-grey-200">
          Nothing in flight right now.
        </p>
      ) : (
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="border-b border-slate-100 text-[11px] font-bold uppercase tracking-[0.08em] text-blue-100">
              <th className="px-5 py-2">Status</th>
              <th className="px-5 py-2 text-right">Links</th>
              <th className="px-5 py-2 text-right">Oldest Claim Age</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr
                key={row.status}
                className="border-b border-slate-50 text-blue-300"
              >
                <td className="px-5 py-2">
                  <Badge
                    label={row.status}
                    colorClasses={ROW_STATUS_BADGE_CLASSES[row.status]}
                  />
                </td>
                <td className="px-5 py-2 text-right">
                  {row.links.toLocaleString()}
                </td>
                <td className="px-5 py-2 text-right">
                  {formatAgeSince(row.oldest_claimed_at)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}

export default StatusSummaryPanel;
